import React, { useEffect, useState } from "react";


import {
  addToCart,
  openMiniCart,
} from "../../../redux/actions/addToCartAction";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setCart } from "../Nosto"

import styles from "../../common/AddToBag/AddToBag.module.scss";

import AddToWishlist from "../AddToWishlist";
import { pushAddToCartEvent, pushCartUpdateEvent } from "@/helpers/cartEventHelper";
import {algoliaConversionTracking} from "@/helpers/productHelper";
import { generalConstants } from "@/utils/constants";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { checkIfFastShippingVariant } from "@/helpers/pdpHelpers/pdpVariantHelpers";
import { addToBag as ATC } from "@/helpers/cartEventHelper";


export default function AddToBag({
  stickyProductBox,
  finalProductPrice,
  product,
  isSizeDropdownOpen,
  setIsSizeDropdownOpen,
  selectedVariant,
  isSizeSelected,
  isFavourite,
  setIsFavourite,
  setSelectedColor,
  setSelectedLetter,
  setSelectedSize,
  badgeCurated,
  hasClass,
  addToBagButtonRef,
  handleAddToBagOverlayObject,
  ...props
}) {
  const cart_list = useSelector((state) => state.click.cart_list);
  let logUser = useSelector((state) => state.loginUser);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [clicked, setOnclick] = useState(false);
  const isSoldOut = isSizeSelected
    ? !selectedVariant?.availableForSale
    : !product?.availableForSale;
  const availableInCountry = product?.availableInCountry;
  const isPreOrder = selectedVariant?.product?.tags?.some(tag => tag.includes(generalConstants.pre_order_tag));
  const defaultButtonText = isSoldOut
    ? "Sold out"
    : availableInCountry? "Add to bag" 
    : isPreOrder ? "Pre order"
    : props?.engravingAdded?.engraving_text?"Add custom item to bag"

        : "Add to bag";
  const isZeroPrice = parseFloat(finalProductPrice?.replace(/[^0-9.-]/g,""))<= 0;
  const buttonClass = isSoldOut || !availableInCountry || isZeroPrice ? styles["disbaled"]: "";
  const buttonZeroPriceClass = isZeroPrice ? styles["sold-out"]: "";
  const displayHeartIcon =
    (typeof product?.tags !== "undefined" &&
      (product?.tags?.includes("sample") || product?.tags?.includes("gift"))) ||
      isSoldOut
      ? false
      : true;
  const [buttonText, setButtonText] = useState(defaultButtonText);
  const isPWAApp = useSelector((state) => state.pwa.is_PWA);

  const addToBag = async (value) => {  
    const activeElement = document.activeElement;//ada - store active element
    var addToBag = true;
    if (!isSizeSelected) {
      setIsSizeDropdownOpen(true);
      addToBag = false;
    }
    if (addToBag) {
      setLoading(true);
      //set loading state for add to bag overlay
      handleAddToBagOverlayObject("loading",true);
      let extraAtt = {
        isPWAApp: isPWAApp,
        engravingAdded: props?.engravingAdded,
      }

      // add to cart function call
      let response = await ATC(selectedVariant, badgeCurated, product, extraAtt);
      dispatch(addToCart(response));
      dispatch(openMiniCart(true));
      setButtonText(value);
      setTimeout(() => {
        setButtonText(defaultButtonText);
      }, 3000);
      setTimeout(() => {
        dispatch(openMiniCart(false));
      }, 5000);
      await setCart(response);
      setLoading(false);
      //set loading state for add to bag overlay
      handleAddToBagOverlayObject("loading",false)
      //call the algolia search tracking function once product is added to cart
      const queryParams = new URLSearchParams(window.location.search)
      const objectID = queryParams.get("objectId");
      //only send the conversion event if object id is present
      //This is done to prevent tracking from from anywhere else expect PLP
      if(objectID){
        algoliaConversionTracking(objectID);
      }
    }
    //ada - retain focus after add to cart
    setTimeout(() => {
      activeElement.focus();
    }, 5000);
  };
  useEffect(() => {
    setButtonText(defaultButtonText);
  }, [defaultButtonText,selectedVariant]);

   //set button text
  useEffect(()=> {
    if(handleAddToBagOverlayObject && buttonText) {
      handleAddToBagOverlayObject("label", buttonText)
    }
  },[buttonText])

  useEffect(() => {
    if (clicked) {
      var data = JSON.parse(localStorage.getItem("pdp_page_view"))

      if (data) {
        // generate ga event based on the selected variant
        const gaAddToCartEvent = props?.engravingAdded?.engraving_text ? "PDP - Add custom item to bag" : checkIfFastShippingVariant(selectedVariant) ? "PDP - fast shipping add to cart" : null;
        pushAddToCartEvent(data, selectedVariant, logUser, window.location.href, gaAddToCartEvent);
        setOnclick(false)
      }
    }

    if (cart_list?.lineItems?.edges?.length) {
      pushCartUpdateEvent(cart_list);
    }
  }, [cart_list])

  useEffect(() => {
    // replace ".add-to-cart-btn" with the class name of your cart button element
    const addToCartButton = document.querySelector(".ga-add-to-bag-btn");
    // replace ".product-title" with the class name of the element containing your product name
    let productName = document.querySelector("#productName").innerHTML;
    console.log("productName: ", productName);
    // replace ".product-img" with the class name of your product img element
    // let productImageURL = document.querySelector(".product-img").src;
    // console.log("productImageURL: ", productImageURL);
    
  })

  return (
    <>
    {/* class inline is added for wishlist alignment */}
      <div className={`add-to-bag-section wishlist-alignment ${styles["button-group"]} ${hasClass ? 'pdp' : ''}`} role="group">
        <button 
          ref={addToBagButtonRef}
          tabIndex={0}
          type="button"
          data-gatrack={`${isSoldOut ? 'ga-sold-out-button-PDP' : ''}`}
          className={`ga-add-to-bag-btn btn-primary small-xs small-sm normal-md btn_loading auto-addToBag-btn ${isSoldOut ? styles["sold-out"] : styles["add-to-bag-btn"]
            } ${loading ? "loading" : ""}
              ${buttonZeroPriceClass}`}
          onClick={() => {
            if (!loading && !isZeroPrice) {
              addToBag("Added to Bag");
              setOnclick(true);
            }
          }}
        >
          <span className="ga-add-to-bag-btn">{props.buttonText || buttonText}</span>
          {!isSoldOut && stickyProductBox && (
            <span className={`${styles["price"]}`}>{finalProductPrice}</span>
          )}
        </button>
        {!isSoldOut && (
          <AddToWishlist
            selectedVariant={selectedVariant}
            finalProductPrice={finalProductPrice}
            product={product}
            favouriteIconHeight={20}
            favouriteIconWidth={20}
            isSizeSelected={isSizeSelected}
            isSizeDropdownOpen={isSizeDropdownOpen}
            setIsSizeDropdownOpen={setIsSizeDropdownOpen}
            setSelectedColor={setSelectedColor}
            setSelectedLetter={setSelectedLetter}
            setSelectedSize={setSelectedSize}
            hasClass={hasClass}
            isPDP={true}
          />
        )}
      </div>
    </>
  );
}